import { rankingItems } from '@/mocks/home';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-600',
  down: 'ri-arrow-down-line text-foreground-500',
  flat: 'ri-subtract-line text-foreground-400',
};

const trendText: Record<string, string> = {
  up: '热度上升',
  down: '热度回落',
  flat: '热度持平',
};

const hourlyHeat = [18, 24, 21, 32, 40, 36, 52, 61, 58, 76, 88, 100];
const hourLabels = ['07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18'];

export default function HeatRanking() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950">
              <i className="ri-fire-line" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热度榜 · 六点场实时排序</h2>
              <p className="mt-1 text-sm text-foreground-600">热度由搬运量、讨论量与跟进账号数综合计算，每 10 分钟刷新一次。</p>
            </div>
          </div>
          <span className="flex h-8 items-center gap-2 self-start rounded-full border border-background-200 bg-background-100 px-3 font-label text-xs text-foreground-600 md:self-auto">
            <i className="ri-time-line" />
            数据时间 18:00
          </span>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-12">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-8">
            <div className="hidden items-center gap-4 border-b border-background-200 px-5 py-3 font-label text-xs text-foreground-500 md:flex">
              <span className="w-10">排名</span>
              <span className="flex-1">事件</span>
              <span className="w-20 text-right">热度</span>
              <span className="w-24 text-right">趋势</span>
            </div>
            <ul>
              {rankingItems.map((item) => (
                <li
                  key={item.rank}
                  className="flex flex-col gap-3 border-b border-background-200 px-4 py-4 transition-colors last:border-b-0 hover:bg-background-50 md:flex-row md:items-center md:gap-4 md:px-5"
                >
                  <div className="flex items-center gap-3 md:contents">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        item.rank <= 3
                          ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                          : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="flex flex-1 flex-col gap-1.5 md:flex-row md:items-center md:gap-3">
                      <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                        {item.title}
                      </h3>
                      <span className="flex h-6 w-fit items-center rounded-md bg-secondary-100 px-2 font-label text-[11px] text-secondary-900">
                        {item.topic}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 pl-11 md:pl-0">
                    <span className="w-20 font-label text-sm font-bold tabular-nums text-foreground-950 md:text-right">
                      {item.heat.toLocaleString()}
                    </span>
                    <span className="flex w-24 items-center gap-1 font-label text-xs text-foreground-600 md:justify-end">
                      <i className={trendIcon[item.trend]} />
                      {trendText[item.trend]}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="flex flex-col gap-5 lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">全天热度走势</h3>
              <p className="mt-1 text-xs text-foreground-600">18:00 为今日峰值节点，与六点场更新时间一致。</p>
              <div className="mt-5 flex h-32 items-end gap-1.5">
                {hourlyHeat.map((value, index) => (
                  <div key={hourLabels[index]} className="flex flex-1 flex-col items-center gap-2">
                    <div className="flex h-24 w-full items-end">
                      <div
                        className={`w-full rounded-t-sm ${
                          index === hourlyHeat.length - 1 ? 'bg-accent-500' : 'bg-primary-300'
                        }`}
                        style={{ height: `${value}%` }}
                      />
                    </div>
                    <span className="font-label text-[9px] tabular-nums text-foreground-500">{hourLabels[index]}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">榜位变化提示</h3>
              <ul className="mt-4 flex flex-col gap-3">
                <li className="flex items-start gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-arrow-up-line" />
                  </span>
                  <p className="text-xs leading-relaxed text-foreground-700">
                    <strong className="font-bold text-foreground-950">美妆主播合约分成</strong> 两小时内上升 4 位，主要来自补充素材的二次传播。
                  </p>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className="ri-arrow-down-line" />
                  </span>
                  <p className="text-xs leading-relaxed text-foreground-700">
                    <strong className="font-bold text-foreground-950">旅行综艺停录</strong> 反转后热度回落，讨论转向节目排期本身。
                  </p>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}